module.exports = __webpack_public_path__ + "static/media/selected_draw.bcaafb6b.svg";